export default __webpack_public_path__ + "static/media/tfevisualizer-icon-grayscale.13449517.svg";